(function () {
  var roots = document.querySelectorAll('.lp-two-series-banner');
  if (!roots.length) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function reveal(root) {
    root.classList.add('is-inview');
  }

  function isVisible(target) {
    var rect = target.getBoundingClientRect();
    var viewH = window.innerHeight || document.documentElement.clientHeight;
    return rect.bottom > 0 && rect.top < viewH;
  }

  roots.forEach(function (root) {
    if (reduced.matches) {
      reveal(root);
      return;
    }

    var target = root.querySelector('.image-banner__wrapper') || root;

    if (isVisible(target)) {
      reveal(root);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      reveal(root);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(root);
          observer.disconnect();
        });
      },
      { threshold: 0.05, rootMargin: '0px' }
    );

    observer.observe(target);

    window.setTimeout(function () {
      if (!root.classList.contains('is-inview')) {
        reveal(root);
      }
    }, 800);
  });
})();
